import { render, staticRenderFns } from "./ShipInfoModal.vue?vue&type=template&id=740b02ec"
import script from "./ShipInfoModal.vue?vue&type=script&lang=ts"
export * from "./ShipInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports